import { get } from 'lodash'
import axios from 'axios'
const baseURL = '/api/test/'

export default class Subquestion {
	constructor (init = {}) {
		this.id = get(init, 'id') ? init.id : null
		this.question_id = get(init, 'question_id') ? init.question_id : null
		this.test_id = get(init, 'test_id') ? init.test_id : null
		this.new_test = get(init, 'new_test') ? init.new_test : false
		this.isOpenTab = true
		this.subquestion = get(init, 'subquestion') ? init.subquestion : ''
		this.subquestion_answer = get(init, 'subquestion_answer') ? init.subquestion_answer : ''
	}

	get formDataDelete () {
		const formData = new URLSearchParams()
		formData.append(`question[0][id]`, this.question_id)
		formData.append(`answer[0][0][subquestion_id]`, this.id)
		formData.append(`answer[0][0][delete]`, 1)
		return formData
	}

	delete () {
		console.log(this)
		return axios.put(`${baseURL}${this.test_id}/question`, this.formDataDelete)
	}

	formData (formData, answerIndex, questionIndex) {
		if (this.id) {
			formData.append(`answer[${questionIndex}][${answerIndex}][subquestion_id]`, this.id)
		}
		formData.append(`answer[${questionIndex}][${answerIndex}][subquestion]`, this.subquestion)
		formData.append(`answer[${questionIndex}][${answerIndex}][subquestion_answer]`, this.subquestion_answer)
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/Test/Subquestion.class.js